import { ProposalStore } from "../../stores/proposalStore";
import { WidgetApiService } from "./widgetApiService";
import { ProposalRequestMapper } from "./proposalRequestMapper";

export interface ProposalService {
  requestProposal: (data: any) => Promise<any>;
}
export class DefaultProposalService implements ProposalService {
  constructor(private proposalStore: ProposalStore, private widgetApiService: WidgetApiService,
    private proposalRequestMapper: ProposalRequestMapper) { }

  public async requestProposal(calculationId: string): Promise<any> {
    const proposalRequest = this.proposalRequestMapper.prepareRequest(calculationId);
    return await this.proposalStore.proposalRequestStatus.handleRequest(
      () => this.widgetApiService.propose(proposalRequest)
    );
  }
}
